/** Distance from the viewport top to the intranet tab bar (platform header + tabs). */
export const RAIL_MENU_OFFSET = 108;

/**
 * Sticky `top` for a side column that scrolls with the page.
 * Shorter than the space under the menus: it stays under the menus.
 * Taller: it keeps moving until its last row is in view, then stays there.
 */
export function railStickyTop(height: number, viewport: number, menuOffset: number): number {
  if (height <= 0 || viewport <= 0) {
    return menuOffset;
  }
  return Math.min(menuOffset, viewport - height);
}
